import Icon from "@ews/react-icons";
import { useL10n } from "@ews/react-localization-context";
import { IonCardContent, IonCardHeader, IonContent, IonItem, IonModal, IonPopover, IonTitle } from "@ionic/react";
import { useIsMobile } from "../../../../../Responsive";
import { breakpoint, getContentMaxHeight } from "../../helper";
import style from "../../LicenseSettings.module.scss";
import { Content } from "./Content";
import { LSTCompanyChoicePopoverProps } from "./types";

export const LSTCompanyChoicePopover: React.FC<LSTCompanyChoicePopoverProps>
    = ({
        isOpen,
        onDismiss,
        onChange,
        onData,
        onOpenInvoiceAddress,
        data = {},
    }) =>
    {
        const { translate: t } = useL10n();

        const mobileView = useIsMobile();

        return mobileView ?

            <IonModal
                isOpen={isOpen}
                initialBreakpoint={breakpoint}
                backdropDismiss
                onDidDismiss={onDismiss}
            >
                <IonItem color={"dark"}>
                    <div
                        className={`${style.marginTop} ${style.center} ${style.flexRowReverse} ${style.justifyBetween}  ${style.with100} ${style.height100}`}>
                        <IonTitle style={{ width: "fit-content", paddingInline: "35px" }}>
                            <div className={`${style.marginTop} ${style.center} ${style.with90} ${style.height100}`}>
                                {t("[REACT_REQUEST_CUSTOMER_NUMBER]")}
                            </div>
                        </IonTitle>
                        <div
                            className={`${style.width10} ${style.height100}`}
                            onClick={onDismiss}
                        >
                            <Icon
                                className={`${style.height100} ${style.width100}`}
                                fill="red"
                                icon={"close"} />
                        </div>
                    </div>
                </IonItem>

                <IonContent>
                    <div style={{ maxHeight: getContentMaxHeight(breakpoint), overflow: "auto" }}>
                        <Content
                            companyLocation={data}
                            onData={onData}
                            onChange={onChange}
                            onDismiss={onDismiss}
                            onOpenInvoiceAddress={onOpenInvoiceAddress}
                        />
                    </div>
                </IonContent>
            </IonModal>
            : <IonPopover
                isOpen={isOpen}
                //ref={LSTCompanyLocationRef}
                className={style.companyPopover}
                backdropDismiss
                onDidDismiss={() =>
                {
                    onDismiss();
                }}
            >
                <IonCardHeader color={"dark"}>
                    <IonTitle >
                        <div className={`${style.marginTop} ${style.center}`}>
                            {t("[REACT_REQUEST_CUSTOMER_NUMBER]")}
                        </div>
                    </IonTitle>
                </IonCardHeader>
                <IonCardContent>
                    <div className={` ${style.center}`}>
                        <div className={`${style.width100}`}>

                            <Content
                                companyLocation={data}
                                onData={onData}
                                onChange={onChange}
                                onDismiss={onDismiss}
                                onOpenInvoiceAddress={onOpenInvoiceAddress}
                            />


                        </div>
                    </div>
                </IonCardContent>
            </IonPopover >;
    };